import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime, tap } from 'rxjs/operators';

import { AuthService, User } from '@core/authentication';
import { AllowedRoleDirective } from '@shared/directives/allowed-role.directive';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: true,
    imports: [MatMenuTrigger, MatIcon, MatMenu, RouterLink, MatMenuItem, TranslatePipe, AllowedRoleDirective]
})
export class UserComponent implements OnInit {
  user!: User;
  displayUserName = '';

  constructor(
    private router: Router,
    private auth: AuthService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.auth
      .user()
      .pipe(
        tap(user => {
          this.user = user;
          this.displayUserName = user.displayName || user.name || user.email || 'user';
          // if username is email remove everything after @
          if (this.displayUserName.includes('@')) {
            this.displayUserName = this.displayUserName.split('@')[0];
            return;
          }
        }),
        debounceTime(10)
      )
      .subscribe(() => this.cdr.detectChanges());
  }

  logout() {
    this.auth.logout().subscribe(() => this.router.navigateByUrl('/auth/login'));
  }
}
